<template>
    <div class="content">
        <Header :idx="'news'"/>

        <div v-if="topList[0]" class="newsPics">
            <a :href="tplGetDetailLink(topList[0].id)" class="left block" target="_blank">
                <div class="left-image cover-image" :style="topList[0].style"></div>
                <span>{{topList[0].title}}</span>
            </a>

            <div class="middle">
                <ul>
                    <li v-for="item in topList.slice(1,5)">
                        <a :href="tplGetDetailLink(item.id)" class="block" target="_blank">
                            <div class="middle-image cover-image" :style="item.style"></div>
                            <span>{{item.title}}</span>
                        </a>
                    </li>
                </ul>
            </div>

            <a v-if="topList.length >= 6" :href="tplGetDetailLink(topList[5].id)" class="right block" target="_blank">
                <div class="right-image cover-image" :style="topList[5].style"></div>
                <!--                <img :src=" topList[5] && topList[5].covers" width="380" height="268">-->
                <span>{{topList[5].title}}</span>
            </a>
        </div>

        <div class="list">
            <div class="new">
                <div class="modTit">最新资讯</div>
                <ListVCoverSummary :list="articleList"/>

                <Paging :total="total" :page="page" :limit="limit" @change="pagingChange"/>
            </div>

            <div class="rank sticky">
                <div class="modTit">文章排行榜</div>
                <ListVRank :list="rankList"/>
            </div>
        </div>


        <Footer/>
    </div>
</template>
<script>
import Header from 'Components/header'
import Footer from 'Components/footer'
import ListVCoverSummary from 'Components/news/list-v-cover-summary.vue'
import ListVRank from 'Components/news/list-v-rank.vue'
import Paging from 'Components/paging.vue'
import request from 'Services/axios'
import {formatNum} from 'Utils/format_num'
import Utils from 'Utils/utils'

export default {
    data() {
        return {
            topList: [],
            rankList: [],

            page: 1,
            total: 0,
            limit: 10,
            articleList: []
        }
    },
    components: {
        Header,
        Footer,
        ListVCoverSummary,
        ListVRank,
        Paging
    },


    created() {

    },

    mounted() {
        this.getData().then(() => {
            if (this.topList.find(a => a.id === 4935)) {
                const script = document.createElement('script');
                script.src = 'http://g.cn.miaozhen.com/x/k=2272276&p=82kbL&dx=__IPDX__&rt=2&pro=n&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&vg=__AUTOPLAY__&nh=__AUTOREFRESH__&o=';
                // script.src = 'http://xx.xx';
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        });
    },


    methods: {
        tplGetDetailLink(id) {
            return Utils.getPageUrl('detail', {id})
        },

        getData() {
            return Promise.all([
                this.geRecommends(),
                this.getRankList(),
                this.getArticleList()
            ])
        },


        //顶部推荐文章
        geRecommends() {
            return request({
                url: '/api/web/article/getRecommends.htm?name=PAGE_NORMAL_TOP&pageSize=30',
                method: 'get',
            }).then((res) => {
                let list = res.data.data.articleList || [];

                list.forEach(item => {
                    item.style = {backgroundImage: `url("${item.covers}")`}

                    item.title = item.title2 || item.title;
                });

                this.topList = list;

                console.log('geRecommends数据=======', this.topList);

            }).catch(error => {
                console.log('geRecommends error', error)
            })
        },


        //文章排行榜
        getRankList() {
            return request({
                url: '/api/web/article/getRanks.htm?type=1&pageSize=9',
                method: 'get',
            }).then((res) => {
                let oriData = res.data;

                this.rankList = oriData.data || {};
                this.rankList.forEach(item => {
                    item.viewCount = formatNum(item.viewCount);
                    item.title = item.title2 || item.title;
                });
            }).catch(error => {
                console.log('getRankList error', error)
            })
        },


        //左下最新资讯
        getArticleList(page = 1) {
            return request({
                url: '/api/web/article/list.htm',
                params: {page, pageSize: this.limit, type: 1}
            }).then((res) => {
                let data = res.data.data;

                this.articleList = (data.itemList || []);
                this.page = page;
                this.total = data.total;

            }).catch(error => {
                console.log('hotList error', error)
            })
        },

        pagingChange(data) {
            this.getArticleList(data.page).then(() => {
                window.scrollTo(0, 470);
            })
        }


    }
};
</script>
<style lang="less" scoped>

.cover-image {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 0.3s;

    &:hover {
        transform: scale3d(1.1, 1.1, 1.1);
    }
}

.content {
    width: 1196px;
    margin: 0 auto;


    .newsPics {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        color: #fff;

        .left-image {
            width: 380px;
            height: 268px;
            overflow: hidden;
        }

        .left {
            cursor: pointer;
            position: relative;
            overflow: hidden;


            span {
                position: absolute;
                bottom: 0;
                left: 0;
                display: block;
                background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%);
                height: 40px;
                width: 100%;
                padding: 8px 0 0 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;


            }

        }

        .middle {
            width: 404px;
            height: 268px;
            overflow: hidden;
            font-size: 16px;

            .middle-image {
                width: 194px;
                height: 130px;
            }

            ul {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;

                li {
                    cursor: pointer;
                    position: relative;
                    width: 194px;
                    height: 130px;
                    overflow: hidden;
                    margin-bottom: 8px;

                    span {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        display: block;
                        height: 36px;
                        width: 100%;
                        padding: 8px 0 0 12px;
                        background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%);
                    }
                }
            }

        }

        .right {
            cursor: pointer;
            width: 380px;
            height: 268px;
            overflow: hidden;
            position: relative;

            .right-image {
                width: 380px;
                height: 268px;
            }

            span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                position: absolute;
                bottom: 0;
                left: 0;
                display: block;
                background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%);
                height: 40px;
                width: 100%;
                padding: 8px 0 0 12px;

            }

        }


    }

    .list {
        margin-top: 32px;
        display: flex;
        justify-content: space-between;

        .modTit {
            height: 65px;
            font-weight: bold;
            padding-top: 16px;
            font-size: 20px;
            color: #363A3E;
        }

        .new {
            width: 800px;
            padding-bottom: 50px;
        }

        font-size: 14px;
        color: #8B9CB7;

        .rank {
            top: 0;
        }

    }


}
</style>
